import React from 'react';

interface AssistantAccordionProps {
  title: string;
  badge?: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

// แผงแบบพับ/กางได้ ให้หน้าตาตรงกับ mockup (details/summary + ลูกศรหมุน)
const AssistantAccordion: React.FC<AssistantAccordionProps> = ({ title, badge, defaultOpen = true, children }) => {
  return (
    <details
      open={defaultOpen}
      className="group rounded-xl overflow-hidden"
      style={{ background: 'var(--component-bg-color)', border: '1px solid var(--bg-item)' }}
    >
      <summary
        className="px-4 py-3 flex items-center justify-between gap-2 cursor-pointer list-none marker:content-none [&::-webkit-details-marker]:hidden"
        style={{ borderBottom: '1px solid var(--bg-item)' }}
      >
        <span className="font-bold text-sm md:text-base flex items-center gap-2 flex-wrap">
          {title}
          {badge && (
            <span
              className="text-sm px-2 py-0.5 rounded-full font-normal"
              style={{ background: 'var(--bg-item)', color: 'var(--text-color)' }}
            >
              {badge}
            </span>
          )}
        </span>
        <span className="text-sm transition-transform group-open:rotate-180" style={{ color: 'var(--yellow-text-color)' }}>
          ▾
        </span>
      </summary>
      {children}
    </details>
  );
};

export default AssistantAccordion;
